<template>
    <div class="row">
        <div id="transition-container">
            <post-entry v-if="postType !== 'infographie'"
                        v-for="post in items"
                        :post="post"
                        class="col-md-12"
                        :key="post.slug">
            </post-entry>
            <infographie-entry v-if="postType === 'infographie'"
                               v-for="post in items"
                               :post="post"
                               class="col-xs-6 col-sm-6 col-md-4"
                               :key="post.slug">
            </infographie-entry>
        </div>

        <div v-if="postType == 'infographie'"
             class="clearfix"
             id="infographie-list-clearfix">
        </div>

        <div class="col-md-12">
            <p v-if="! hasPosts && ! isLoading">Aucun article trouvé...</p>
        </div>

        <div v-if="showPagination" class="col-md-12">
            <div is="uib-pagination"
                 v-model="pagination"
                 :total-items="wpTotal"
                 :boundary-link-numbers="true"
                 :max-size="5"
                 previous-text="«"
                 next-text="»"
                 @change="fetch(pagination.currentPage)">
            </div>
        </div>
    </div>
</template>

<script>
    import PostEntry from './PostEntry.vue'
    import InfographieEntry from './InforgraphieEntry.vue'
    import _ from 'lodash'

    export default {
        components: {
            PostEntry,
            InfographieEntry,
        },
        data () {
            return {
                pagination: {
                    currentPage: 1,
                    numPages: 0,
                    total: 0
                },
                items: [],
                isLoading: true,
                postType: null,
                wpTotal: 0,
                wpTotalPages: 0,
                isSearchPage: false,
                isThematiquePage: false,
                searchForTypes: [],
                search: {
                    year: null,
                    month: null
                },
            }
        },
        computed: {
            hasPosts () {
                return this.items.length > 0
            },
            showPagination () {
                return this.wpTotalPages > 1
            }
        },
        methods: {
            fetch (page) {
                this.scrollToTopOfPosts()
                this.isLoading = true

                let params = this.isSearchPage ? {
                    _embed: 'featuredmedia',
                    s: window.initialState.searchFor,
                    post_type: this.searchForTypes ? this.searchForTypes.join() : ''
                } : {
                    _embed: 'featuredmedia',
                    'filter[year]': this.search.year,
                    'filter[monthnum]': this.search.month
                }


                this.$http
                    .get(this.url(page), {
                        params: params
                    })
                    .then(this.refresh)
                    .catch(error => {
                        this.isLoading = false
                    })
            },
            url (page) {
                this.pagination.currentPage = page

                if (this.isSearchPage) {
                  return `${apiUrl}oip/v1/search?page=${page}`
                }

                if (this.isThematiquePage) {
                  return `${apiUrl}oip/v1/thematique_posts/${window.initialState.thematiqueId}?page=${page}`
                }

                return `${apiUrl}wp/v2/${this.postType}s?page=${page}`
            },
            refresh (response) {
                this.items = response.body
                this.pagination.totalItems = parseInt(response.headers.get('X-WP-Total'))
                this.pagination.numPages = parseInt(response.headers.get('X-WP-TotalPages'))
                this.wpTotal = parseInt(response.headers.get('X-WP-Total'))
                this.wpTotalPages = parseInt(response.headers.get('X-WP-TotalPages'))
                this.isLoading = false
            },
            getInitialState () {
                this.items = window.initialState.posts
                this.pagination.totalItems = window.initialState.wpTotal
                this.pagination.numPages = window.initialState.wpTotalPages
                this.postType = window.initialState.postType
                this.wpTotal = window.initialState.wpTotal
                this.wpTotalPages = window.initialState.wpTotalPages
                this.isSearchPage = window.initialState.hasOwnProperty('isSearchPage')
                    ? window.initialState.isSearchPage
                    : false
                this.isThematiquePage = window.initialState.hasOwnProperty('isThematiquePage')
                    ? window.initialState.isThematiquePage
                    : false
            },
            flushPosts () {
                this.items = []
            },
            listenToSearchByDate () {
                let form = window.document.getElementById('search-by-date')
                form.addEventListener('change', () => {
                    let date = _.trim(form.value, window.siteUrl)
                    date = _.split(date, '/?')[0]
                    this.search.year = parseInt(_.split(date, '/')[0]) || ''
                    this.search.month = parseInt(_.split(date, '/')[1]) || ''
                    this.pagination.currentPage = 1
                    this.flushPosts()
                    this.fetch(this.pagination.currentPage)
                })
            },
            listenToSearchSubmit () {
                document.getElementById('search-submit-button').addEventListener('click', e => {
                    e.preventDefault()
                    this.flushPosts()
                    this.searchForTypes = []
                    let button = e.target || e.srcElement
                    _.forEach(button.form.querySelectorAll('input[type="checkbox"]'), checkbox => {
                        if (checkbox.checked) {
                            this.searchForTypes.push(checkbox.value)
                        }
                    })
                    this.pagination.currentPage = 1
                    // @todo - 2017-09-20 - I don't know what's the point of this.paginate
                    // so I check if it is defined before messing everything up...
                    if (typeof this.paginate !== 'undefined') {
                      this.paginate.posts.page = 0
                    }
                    this.fetch(this.pagination.currentPage)
                })
            },
            scrollToTopOfPosts (toPage, fromPage) {
                if (this.postType === 'infographie') {
                    document.getElementById('transition-container').classList.add('loading')
                    setTimeout(() => {
                        document.getElementById('top-for-scroll').scrollIntoView({
                            behavior: 'smooth'
                        });
                        document.getElementById('transition-container').classList.remove('loading')
                    }, 200)
                } else {
                    document.getElementById('top-for-scroll').scrollIntoView({
                        behavior: 'smooth'
                    });
                }
            }
        },
        watch: {
            isLoading (value) {
                value
                    ? document.getElementById('app-container').classList.add('loading')
                    : document.getElementById('app-container').classList.remove('loading')
            },
        },
        mounted () {
            this.getInitialState()
            this.isLoading = false

            if (! this.isSearchPage) {
                if (! document.body.classList.contains('tax-thematique')
                    && ! document.body.classList.contains('page-template-liste-infographies')) {
                    this.listenToSearchByDate()
                }
            } else {
                this.listenToSearchSubmit()
            }
        }
    }
</script>



// WEBPACK FOOTER //
// resources/assets/js/components/posts/PostList.vue